module.exports = __webpack_public_path__ + "media/BrightOff.719dd185.wav";